module Omni.Core {
    export interface IProfileService {
        GetProfile();
    }

    class ProfileService implements IProfileService {
        static $inject = [
            "$http",
            "$log"
        ];
        constructor(
            private readonly $http: ng.IHttpService,
            private readonly $log: ng.ILogService
        ) {
        }

        GetProfile() {
            const cfg = {
                jsonpCallbackParam: "callback"
            };

            return this.$http.jsonp("/profile/profile/myaccount", cfg)
                .then((response: any) => {
                    return response.data.Data;
                }).catch((exception) => {
                    this.$log.debug(exception);
                });
        }
    }

    ngModule.service("omni.core.profileservice", ProfileService);
}
